module.exports = __webpack_public_path__ + "static/media/0.76b13a4a.png";